/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */

//虚假用户名校验
export function validUsername(str) {
  const valid_map = ['admin', 'director','manager','person_in_charge','people']
  return valid_map.indexOf(str.trim()) >= 0
}
